module.exports = __webpack_public_path__ + "assets/10.jpg?b72daec663e111095b18ccbf11aeabb8";